import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["htmlSize"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["placement"],
  _excluded4 = ["placement"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ../../../react-shim.js
import React from "react";

// src/input.tsx
import { useFormControl } from "@chakra-ui/form-control";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
var Input = forwardRef(function Input2(props, ref) {
  var htmlSize = props.htmlSize,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = useMultiStyleConfig("Input", rest);
  var ownProps = omitThemingProps(rest);
  var input = useFormControl(ownProps);
  var _className = cx("chakra-input", props.className);
  return /* @__PURE__ */React.createElement(chakra.input, _objectSpread(_objectSpread({
    size: htmlSize
  }, input), {}, {
    __css: styles.field,
    ref: ref,
    className: _className
  }));
});
Input.displayName = "Input";
Input.id = "Input";

// src/input-addon.tsx
import { chakra as chakra3, forwardRef as forwardRef3 } from "@chakra-ui/system";
import { cx as cx3 } from "@chakra-ui/shared-utils";

// src/input-group.tsx
import { createContext } from "@chakra-ui/react-context";
import { getValidChildren } from "@chakra-ui/react-children-utils";
import { chakra as chakra2, forwardRef as forwardRef2, omitThemingProps as omitThemingProps2, useMultiStyleConfig as useMultiStyleConfig2 } from "@chakra-ui/system";
import { cx as cx2 } from "@chakra-ui/shared-utils";
import { compact } from "@chakra-ui/object-utils";
import { cloneElement } from "react";
var _createContext = createContext({
    name: "InputGroupStylesContext",
    errorMessage: "useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<InputGroup />\" "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  InputGroupStylesProvider = _createContext2[0],
  useInputGroupStyles = _createContext2[1];
var InputGroup = forwardRef2(function InputGroup2(props, ref) {
  var styles = useMultiStyleConfig2("Input", props);
  var _omitThemingProps = omitThemingProps2(props),
    children = _omitThemingProps.children,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded2);
  var _className = cx2("chakra-input__group", className);
  var groupStyles = {};
  var validChildren = getValidChildren(children);
  var input = styles.field;
  validChildren.forEach(function (child) {
    if (!styles) return;
    if (input && child.type.id === "InputLeftElement") {
      var _input$height;
      groupStyles.paddingStart = (_input$height = input.height) !== null && _input$height !== void 0 ? _input$height : input.h;
    }
    if (input && child.type.id === "InputRightElement") {
      var _input$height2;
      groupStyles.paddingEnd = (_input$height2 = input.height) !== null && _input$height2 !== void 0 ? _input$height2 : input.h;
    }
    if (child.type.id === "InputRightAddon") {
      groupStyles.borderEndRadius = 0;
    }
    if (child.type.id === "InputLeftAddon") {
      groupStyles.borderStartRadius = 0;
    }
  });
  var clones = validChildren.map(function (child) {
    var _a, _b;
    var theming = compact({
      size: ((_a = child.props) == null ? void 0 : _a.size) || props.size,
      variant: ((_b = child.props) == null ? void 0 : _b.variant) || props.variant
    });
    return child.type.id !== "Input" ? cloneElement(child, theming) : cloneElement(child, Object.assign(theming, groupStyles, child.props));
  });
  return /* @__PURE__ */React.createElement(chakra2.div, _objectSpread({
    className: _className,
    ref: ref,
    __css: {
      width: "100%",
      display: "flex",
      position: "relative"
    }
  }, rest), /* @__PURE__ */React.createElement(InputGroupStylesProvider, {
    value: styles
  }, clones));
});
InputGroup.displayName = "InputGroup";

// src/input-addon.tsx
var placements = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
};
var StyledAddon = chakra3("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
});
var InputAddon = forwardRef3(function InputAddon2(props, ref) {
  var _placements$placement;
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? "left" : _props$placement,
    rest = _objectWithoutProperties(props, _excluded3);
  var placementStyles = (_placements$placement = placements[placement]) !== null && _placements$placement !== void 0 ? _placements$placement : {};
  var styles = useInputGroupStyles();
  return /* @__PURE__ */React.createElement(StyledAddon, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    __css: _objectSpread(_objectSpread({}, styles.addon), placementStyles)
  }));
});
InputAddon.displayName = "InputAddon";
var InputLeftAddon = forwardRef3(function InputLeftAddon2(props, ref) {
  return /* @__PURE__ */React.createElement(InputAddon, _objectSpread(_objectSpread({
    ref: ref,
    placement: "left"
  }, props), {}, {
    className: cx3("chakra-input__left-addon", props.className)
  }));
});
InputLeftAddon.displayName = "InputLeftAddon";
InputLeftAddon.id = "InputLeftAddon";
var InputRightAddon = forwardRef3(function InputRightAddon2(props, ref) {
  return /* @__PURE__ */React.createElement(InputAddon, _objectSpread(_objectSpread({
    ref: ref,
    placement: "right"
  }, props), {}, {
    className: cx3("chakra-input__right-addon", props.className)
  }));
});
InputRightAddon.displayName = "InputRightAddon";
InputRightAddon.id = "InputRightAddon";

// src/input-element.tsx
import { chakra as chakra4, forwardRef as forwardRef4 } from "@chakra-ui/system";
import { cx as cx4 } from "@chakra-ui/shared-utils";
var StyledInputElement = chakra4("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
});
var InputElement = forwardRef4(function InputElement2(props, ref) {
  var _ref, _ref2, _objectSpread2;
  var _props$placement2 = props.placement,
    placement = _props$placement2 === void 0 ? "left" : _props$placement2,
    rest = _objectWithoutProperties(props, _excluded4);
  var styles = useInputGroupStyles();
  var input = styles.field;
  var attr = placement === "left" ? "insetStart" : "insetEnd";
  var elementStyles = _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, attr, "0"), _defineProperty(_objectSpread2, "width", (_ref = input == null ? void 0 : input.height) !== null && _ref !== void 0 ? _ref : input == null ? void 0 : input.h), _defineProperty(_objectSpread2, "height", (_ref2 = input == null ? void 0 : input.height) !== null && _ref2 !== void 0 ? _ref2 : input == null ? void 0 : input.h), _defineProperty(_objectSpread2, "fontSize", input == null ? void 0 : input.fontSize), _objectSpread2), styles.element);
  return /* @__PURE__ */React.createElement(StyledInputElement, _objectSpread({
    ref: ref,
    __css: elementStyles
  }, rest));
});
InputElement.id = "InputElement";
InputElement.displayName = "InputElement";
var InputLeftElement = forwardRef4(function InputLeftElement2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded5);
  var _className = cx4("chakra-input__left-element", className);
  return /* @__PURE__ */React.createElement(InputElement, _objectSpread({
    ref: ref,
    placement: "left",
    className: _className
  }, rest));
});
InputLeftElement.id = "InputLeftElement";
InputLeftElement.displayName = "InputLeftElement";
var InputRightElement = forwardRef4(function InputRightElement2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded6);
  var _className = cx4("chakra-input__right-element", className);
  return /* @__PURE__ */React.createElement(InputElement, _objectSpread({
    ref: ref,
    placement: "right",
    className: _className
  }, rest));
});
InputRightElement.id = "InputRightElement";
InputRightElement.displayName = "InputRightElement";
export { Input, InputAddon, InputGroup, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement, useInputGroupStyles };